var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,188.458l1250,0l0,792.221l-1250,0l0,-792.221Zm629.454,719.067c14.225,2.158 25.129,14.425 25.129,29.246c0,16.341 -13.221,29.567 -29.562,29.567c-16.342,-0 -29.567,-13.226 -29.567,-29.567c0,-14.821 10.867,-27.088 25.129,-29.246l0,-5.392c0,-5.833 8.913,-5.833 8.913,0l-0,5.392l-0.042,0Zm0,6.712l0,20.538c0,5.833 -8.908,5.833 -8.908,0l-0,-20.538c-10.55,2.08 -18.5,11.388 -18.5,22.534c-0,12.666 10.271,22.933 22.975,22.933c12.662,0 22.971,-10.267 22.971,-22.933c-0,-11.146 -7.988,-20.454 -18.496,-22.534l-0.042,0Zm-327.012,147.305c-43.788,-0 -43.788,-66.6 -0,-66.6l645.075,-0c43.791,-0 43.791,66.6 -0,66.6l-645.075,-0Zm-249.705,-820.267l1144.48,0l-0,643l-1144.48,0l0,-643Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.737,
    y: 241.275,
    width: 1144.48,
    height: 643,
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.7e5bcebf.svg";
export { ForwardRef as ReactComponent };